import type { Id } from '../../api/types';
import { i18n } from '../../i18n/index.ts';
import { type MaybeMsg } from '../../i18n/msg.ts';

export interface RosterStatus {
  count: number;
  loading: boolean;
  error: MaybeMsg | null;
  // false until the first load() has started; an idle empty store is not an empty class
  requested: boolean;
}

export interface ConductInput {
  classNoteId: Id | undefined;
  subjectId: Id | undefined;
  semester: Id | null;
  roster: RosterStatus;
}

/** Why Thêm is off ('' when live) and whether a retry can fix it - a disabled button with no reason reads as broken. */
export interface ConductGate {
  reason: string;
  retry: boolean;
}

// Getters, not constants: a string frozen at import time would ignore the language the teacher picks later.
export const CONDUCT_COPY = {
  get noClassNote(): string { return i18n.t('panels:conduct.gate.noClassNote'); },
  get noSubject(): string { return i18n.t('panels:conduct.gate.noSubject'); },
  get noSemester(): string { return i18n.t('panels:conduct.gate.noSemester'); },
  get rosterLoading(): string { return i18n.t('panels:conduct.gate.rosterLoading'); },
  get rosterError(): string { return i18n.t('panels:conduct.gate.rosterError'); },
  get rosterEmpty(): string { return i18n.t('panels:conduct.gate.rosterEmpty'); },
};

export function conductGate({ classNoteId, subjectId, semester, roster }: ConductInput): ConductGate {
  if (!classNoteId) return { reason: CONDUCT_COPY.noClassNote, retry: false };
  if (!subjectId) return { reason: CONDUCT_COPY.noSubject, retry: false };
  if (semester === null) return { reason: CONDUCT_COPY.noSemester, retry: false };
  if (roster.count > 0) return { reason: '', retry: false };
  if (roster.loading || !roster.requested) return { reason: CONDUCT_COPY.rosterLoading, retry: false };
  if (roster.error) return { reason: CONDUCT_COPY.rosterError, retry: true };
  return { reason: CONDUCT_COPY.rosterEmpty, retry: false };
}
